const Money = {
  methods: {
    formatMoney(number) {
      if(!number) return ''
      return number.toLocaleString('pt-BR', {maximumFractionDigits: 2, minimumFractionDigits: 2});
    }
  }
}

export default Money
